import { WmButton } from "@watermarkinsights/ripple-react";
import { InstitutionIcon } from "@/features/common/Icons";
import { Organization } from "./ContributorInsights";
import { useContext, useReducer } from "react";
import { useIntl } from "react-intl";
import translate from "@/i18n/translate";
import { AppContext, AppContextInterface } from "@/contexts/AppContext";
import { useNavigate } from "react-router-dom";
import { scrollToTop } from "@/features/common/helper";

interface ContributorOrganizationInsightsProps {
  organizations: Organization[];
}
interface State {
  showOrganizations: boolean;
}
interface Action {
  type: string;
  showOrganizations: boolean;
}
const defaultAction: Action = {
  type: "",
  showOrganizations: false
};

const stateReducer = (state: State, action: Action) => {
  switch (action.type) {
    case "toggleOrganizations":
      return {
        ...state,
        showOrganizations: !state.showOrganizations
      };
    default:
      return state;
  }
};

const initialState: State = {
  showOrganizations: true
};

export function ContributorOrganizationInsights({
  organizations
}: ContributorOrganizationInsightsProps) {
  const [state, dispatch] = useReducer(stateReducer, initialState);
  const toggleOrganizations = () => {
    dispatch({ ...defaultAction, type: "toggleOrganizations" });
  };
  const toggleOrganizationsLabel = useIntl().formatMessage({
    id: "app.home.toggleOrganizations"
  });
  return (
    <div className="my-institution-container">
      <div className="flex-row -verticallycentered">
        <button
          className={
            state.showOrganizations
              ? "expand-button mdi  mdi-menu-down"
              : "expand-button mdi  mdi-menu-right"
          }
          onClick={toggleOrganizations}
          aria-label={toggleOrganizationsLabel}
        ></button>
        <span className="my-institution">
          {translate("app.home.myOrganizations")}
        </span>
      </div>
      <div id="organization-list-container">
        {state.showOrganizations &&
          organizations.map((organization: Organization) => {
            return (
              <OrganizationCard
                organization={organization}
                key={`${organization.uuid} ${organization.code}`}
              />
            );
          })}
      </div>
    </div>
  );
}
interface OrganizationCardProps {
  organization: Organization;
}
const OrganizationCard = ({ organization }: OrganizationCardProps) => {
    const { institution } = useContext<AppContextInterface>(AppContext);
    const navigate = useNavigate();
    const queryString = window.location.search;
    const organizationInsightsUrl = queryString.includes("locale")
      ? `/insights/institution/${institution?.platformUuid}/organization/${organization.uuid}/${queryString}`
      : `/insights/institution/${institution?.platformUuid}/organization/${organization.uuid}`;
    function navigateToUrl(url: string) {
      scrollToTop(".home-page-header");
      navigate(url);
    }
    return (
      <div className="institution-name">
        < InstitutionIcon/>
        <div className="organization-button">
          <WmButton
            buttonType="textonly"
            onClick={() => navigateToUrl(organizationInsightsUrl)}
          >
            <div className="instiution-link">{organization.name}</div>
          </WmButton>
        </div>
      </div>
    );
  };
  
